import { toString as toString_1, Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { obj_type, union_type, string_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { cons, empty, ofArray, tail, head, isEmpty } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { int32ToString, uncurry2, createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { reactApi } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "./Context.js";
import { hierarchyContext } from "./CompanyHierarchyContext.js";
import { tryFind } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { testRedirect, extraCoders, Machine_fetchMachineInfo } from "./Promises.js";
import { API_Customer_Customer } from "./Shared/Urls.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { CustomerInfo_$reflection } from "./Shared/ApiDataTypes.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { value as value_130, unwrap, map, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { MachineViewInfo } from "./Machine/Types.js";
import { empty as empty_1, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { loadingIndicator, SnackAlertLevel, SnackAlert } from "./ViewHelpers.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Tab, Tabs, Alert, Link, Breadcrumbs, Typography } from "@mui/material";
import { Machine_getNameOrCode } from "./Shared/Shared.js";
import { now, compare } from "./fable_modules/fable-library-js.4.24.0/Date.js";
import { RouterModule_nav, RouterModule_encodeParts } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { join } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { Machine_Overview_Z259FB9E } from "./Machine/Overview.js";
import { infoToMachine, Activities } from "./ActivityView.js";
import { Target } from "./Activities/Services.js";
import { View, Target as Target_1 } from "./Economy.js";
import { GasReport_View_Z6C265741 } from "./GasReport.js";
import { OrderView } from "./SpareParts.js";
import { ListTarget, List } from "./Ticket/CustomerTicketList.js";
import { Documents_View_Z721C83C5 } from "./DocumentView.js";
import { Provider } from "./Documents/DocumentContext.js";
import { DocumentTreeWithFilter } from "./Machine/MachineDocumentTree.js";

class SubView extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Overview", "ActivityPlan", "Economy", "GasReport", "SpareParts", "Documents", "Document", "Tickets", "NotFound"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "activity-plan" : ((this$.tag === 2) ? "economy" : ((this$.tag === 3) ? "gasreport" : ((this$.tag === 4) ? "spareparts" : ((this$.tag === 5) ? "documents" : ((this$.tag === 6) ? (`documents/${this$.fields[0]}`) : ((this$.tag === 7) ? "tickets" : ((this$.tag === 8) ? "not-found" : "overview")))))));
    }
}

function SubView_$reflection() {
    return union_type("Kundeweb.SubView", [], SubView, () => [[], [], [], [], [], [], [["Item", string_type]], [], []]);
}

function SubView_ofString_7F866359(path) {
    let matchResult, documentId;
    if (!isEmpty(path)) {
        switch (head(path)) {
            case "overview": {
                if (isEmpty(tail(path))) {
                    matchResult = 0;
                }
                else {
                    matchResult = 8;
                }
                break;
            }
            case "activity-plan": {
                if (isEmpty(tail(path))) {
                    matchResult = 1;
                }
                else {
                    matchResult = 8;
                }
                break;
            }
            case "economy": {
                matchResult = 2;
                break;
            }
            case "gasreport": {
                if (isEmpty(tail(path))) {
                    matchResult = 3;
                }
                else {
                    matchResult = 8;
                }
                break;
            }
            case "spareparts": {
                if (isEmpty(tail(path))) {
                    matchResult = 4;
                }
                else {
                    matchResult = 8;
                }
                break;
            }
            case "documents": {
                if (!isEmpty(tail(path))) {
                    if (isEmpty(tail(tail(path)))) {
                        matchResult = 6;
                        documentId = head(tail(path));
                    }
                    else {
                        matchResult = 8;
                    }
                }
                else {
                    matchResult = 5;
                }
                break;
            }
            case "tickets": {
                if (isEmpty(tail(path))) {
                    matchResult = 7;
                }
                else {
                    matchResult = 8;
                }
                break;
            }
            default:
                matchResult = 8;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return new SubView(0, []);
        case 1:
            return new SubView(1, []);
        case 2:
            return new SubView(2, []);
        case 3:
            return new SubView(3, []);
        case 4:
            return new SubView(4, []);
        case 5:
            return new SubView(5, []);
        case 6:
            return new SubView(6, [documentId]);
        case 7:
            return new SubView(7, []);
        default:
            return new SubView(8, []);
    }
}

function SubView__get_Id(this$) {
    switch (this$.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        case 4:
            return 4;
        case 7:
            return 5;
        case 6:
        case 5:
            return 6;
        case 8:
            return -1;
        default:
            return 0;
    }
}

function SubView_FromInt_Z524259A4(x) {
    switch (x) {
        case 0:
            return new SubView(0, []);
        case 1:
            return new SubView(1, []);
        case 2:
            return new SubView(2, []);
        case 3:
            return new SubView(3, []);
        case 4:
            return new SubView(4, []);
        case 5:
            return new SubView(7, []);
        case 6:
            return new SubView(5, []);
        default:
            return new SubView(8, []);
    }
}

function Machine_noInfo() {
    let elems;
    return createElement("div", createObj(ofArray([["style", {
        padding: 20,
    }], (elems = [createElement("span", {
        style: {
            fontSize: 0.8 + "rem",
            fontStyle: "italic",
        },
        children: "Ingen data.",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

/**
 * The containing view when you've selected a machine under the "Customer site"
 */
export function Machine_View_41E5FE05(machine_View_41E5FE05InputProps) {
    const path = machine_View_41E5FE05InputProps.path;
    const groupId = machine_View_41E5FE05InputProps.groupId;
    const customerId = machine_View_41E5FE05InputProps.customerId;
    const machineId = machine_View_41E5FE05InputProps.machineId;
    const ctx = reactApi.useContext(ctx_1);
    const hierarchy = reactApi.useContext(hierarchyContext);
    const patternInput = reactApi.useState(true);
    const setLoading = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const info = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const setErrMsg = patternInput_2[1];
    const subView = SubView_ofString_7F866359(path);
    const customerGroupOpt = tryFind((group) => (group.Id === groupId), hierarchy.Groups);
    const dependencies = [machineId];
    reactApi.useEffect(() => {
        console.debug("Mounting machine %i view", machineId);
        const pr_3 = Machine_fetchMachineInfo(machineId);
        pr_3.then((res) => {
            let properties_2;
            if (res.tag === 0) {
                const machineInfo = res.fields[0];
                const url = API_Customer_Customer(machineInfo.CustomerId);
                let pr_2;
                let pr_1;
                const decoder = Auto_generateBoxedDecoder_Z6670B51(CustomerInfo_$reflection(), undefined, undefined);
                const data_1 = undefined;
                const caseStrategy_2 = undefined;
                const extra_2 = extraCoders;
                try {
                    const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg_1) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(CustomerInfo_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_2) => {
                            let matchValue_1;
                            return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
                }
                catch (exn) {
                    pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
                pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
                pr_2.then((res_1) => {
                    setLoading(false);
                    if (res_1.tag === 1) {
                        setErrMsg("Kunne ikke laste kundeinfo. Prøv igjen senere");
                    }
                    else {
                        patternInput_1[1](new MachineViewInfo(machineInfo, res_1.fields[0]));
                    }
                });
            }
            else if (res.fields[0].tag === 2) {
                if ((res.fields[0].fields[0].status) === 403) {
                    setErrMsg(ctx.Locale.t("NoAccess"));
                }
                else {
                    setErrMsg(ctx.Locale.t("MachineView.InfoFailed"));
                }
                setLoading(false);
            }
            else {
                setErrMsg(ctx.Locale.t("MachineView.InfoFailed"));
                setLoading(false);
            }
        });
    }, dependencies);
    const xs_10 = toList(delay(() => {
        let $keyZ4A641708;
        return append(singleton(($keyZ4A641708 = (`machine-${machineId}-snack-error`), createElement(SnackAlert, {
            key: $keyZ4A641708,
            $key: $keyZ4A641708,
            level: new SnackAlertLevel(0, []),
            msg: unwrap(patternInput_2[0]),
            dismiss: () => {
                setErrMsg(undefined);
            },
        }))), delay(() => {
            let elems, elems_1, elems_9;
            if (patternInput[0]) {
                return singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                }], (elems = [MuiHelpers_createElement(Typography, [["children", "Laster anlegg..."]]), loadingIndicator()], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
            }
            else if ((info == null) ? true : (customerGroupOpt == null)) {
                return singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                }], (elems_1 = [MuiHelpers_createElement(Typography, [["children", "Du har ikke tilgang til dette anlegget"]])], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
            }
            else {
                const machineInfo_1 = value_130(info).Machine;
                const customer = value_130(info).Customer;
                const machineNameOrCode = Machine_getNameOrCode({
                    code: machineInfo_1.Code,
                    name: machineInfo_1.Name,
                });
                let isRemoved;
                const matchValue_2 = machineInfo_1.Removed;
                if (matchValue_2 != null) {
                    const removed = matchValue_2;
                    try {
                        isRemoved = (compare(removed, now()) < 0);
                    }
                    catch (matchValue_3) {
                        isRemoved = false;
                    }
                }
                else {
                    isRemoved = false;
                }
                return append(singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    width: 100 + "%",
                    rowGap: 10 + "px",
                    padding: ((0 + "px") + " ") + (10 + "px"),
                }], (elems_9 = toList(delay(() => {
                    let elems_3, elements;
                    return append(singleton(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        width: 100 + "%",
                    }], (elems_3 = [MuiHelpers_createElement(Breadcrumbs, [(elements = [MuiHelpers_createElement(Link, [["href", RouterModule_encodeParts(ofArray(["group", int32ToString(groupId)]), 1)], ["children", value_130(customerGroupOpt).Name]]), MuiHelpers_createElement(Link, [["href", RouterModule_encodeParts(ofArray(["group", int32ToString(groupId), "customer", int32ToString(machineInfo_1.CustomerId)]), 1)], ["children", machineInfo_1.CustomerName]]), MuiHelpers_createElement(Link, [["className", join(" ", ["selected"])], ["href", RouterModule_encodeParts(ofArray(["group", int32ToString(groupId), "customer", int32ToString(machineInfo_1.CustomerId), "machine", int32ToString(machineInfo_1.Id)]), 1)], ["classes.root", "hover-link"], ["children", machineNameOrCode]])], ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                        let elems_5, elems_4;
                        return append(singleton(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            alignItems: "center",
                            width: 100 + "%",
                        }], (elems_5 = [createElement("div", createObj(ofArray([["style", {
                            flexGrow: 1,
                            minWidth: 100 + "px",
                        }], (elems_4 = [MuiHelpers_createElement(Typography, [["title", machineInfo_1.Name], ["variant", "h1"], ["noWrap", true], ["children", machineInfo_1.Name]])], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                            let elems_7, elements_1;
                            return append(isRemoved ? singleton(createElement("div", createObj(ofArray([["style", {
                                display: "flex",
                                justifyContent: "center",
                                margin: ((((((20 + "px ") + 0) + "px ") + 10) + "px ") + 0) + "px",
                            }], (elems_7 = [MuiHelpers_createElement(Alert, [["variant", "outlined"], ["severity", "warning"], (elements_1 = [ctx.Locale.t("MachineView.IsRemoved")], ["children", reactApi.Children.toArray(Array.from(elements_1))])])], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))) : empty_1(), delay(() => {
                                let elements_2;
                                return singleton(MuiHelpers_createElement(Tabs, [["centered", false], ["variant", "scrollable"], ["indicatorColor", "primary"], ["textColor", "primary"], ["sx", {
                                    width: 100 + "%",
                                }], ["value", SubView__get_Id(subView)], ["onChange", (_arg_4, v) => {
                                    const newSubViewStr = toString_1(SubView_FromInt_Z524259A4(v));
                                    RouterModule_nav(ofArray(["group", int32ToString(groupId), "customer", int32ToString(customerId), "machine", int32ToString(machineId), newSubViewStr]), 1, 1);
                                }], (elements_2 = toList(delay(() => append(singleton(MuiHelpers_createElement(Tab, [["value", SubView__get_Id(new SubView(0, []))], ["label", ctx.Locale.t("CustomerSite.Tabs.Overview")]])), delay(() => append(customer.EnableServices ? singleton(MuiHelpers_createElement(Tab, [["value", SubView__get_Id(new SubView(1, []))], ["label", ctx.Locale.t("CustomerSite.Tabs.ActivityPlan")]])) : empty_1(), delay(() => append(singleton(MuiHelpers_createElement(Tab, [["value", SubView__get_Id(new SubView(2, []))], ["label", ctx.Locale.t("CustomerSite.Tabs.Economy")]])), delay(() => append(singleton(MuiHelpers_createElement(Tab, [["value", SubView__get_Id(new SubView(3, []))], ["label", ctx.Locale.t("CustomerSite.Tabs.GasReport")]])), delay(() => append(singleton(MuiHelpers_createElement(Tab, [["value", SubView__get_Id(new SubView(4, []))], ["label", ctx.Locale.t("CustomerSite.Tabs.SpareParts")]])), delay(() => {
                                    let matchValue_4, s;
                                    return append((matchValue_4 = ctx.Session, (matchValue_4 != null) ? ((s = matchValue_4, ((!s.TicketAccess && !s.IsAdmin) && !s.IsPtg) ? (empty_1()) : singleton(MuiHelpers_createElement(Tab, [["value", SubView__get_Id(new SubView(7, []))], ["label", ctx.Locale.t("CustomerSite.Tabs.Tickets")]])))) : (empty_1())), delay(() => singleton(MuiHelpers_createElement(Tab, [["value", SubView__get_Id(new SubView(5, []))], ["label", ctx.Locale.t("CustomerSite.Tabs.Documents")]]))));
                                })))))))))))), ["children", reactApi.Children.toArray(Array.from(elements_2))])]));
                            }));
                        }));
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))), delay(() => {
                    let elems_10, target, $key65EB108D, $keyZ7232EB07, $key4DB85DF3;
                    return singleton(createElement("div", createObj(ofArray([["className", join(" ", ["rounded-container", "main-tab-container-outer"])], (elems_10 = [createElement("div", {
                        className: join(" ", ["main-tab-container-inner"]),
                        children: (subView.tag === 0) ? createElement(Machine_Overview_Z259FB9E, {
                            info: value_130(info),
                            groupId: groupId,
                            customerId: customerId,
                        }) : ((subView.tag === 1) ? createElement(Activities, {
                            target: new Target(2, [groupId, customerId, machineId, infoToMachine(machineInfo_1)]),
                        }) : ((subView.tag === 2) ? ((target = (new Target_1(0, [customerId, machineId])), ($key65EB108D = toString_1(target), createElement(View, {
                            key: $key65EB108D,
                            $key: $key65EB108D,
                            target: target,
                        })))) : ((subView.tag === 3) ? createElement(GasReport_View_Z6C265741, {
                            groupId: groupId,
                            customerId: customerId,
                            machineId: machineId,
                        }) : ((subView.tag === 4) ? createElement(OrderView, machineInfo_1) : ((subView.tag === 7) ? createElement(List, {
                            target: new ListTarget(2, [groupId, customer.Id, machineId]),
                        }) : ((subView.tag === 6) ? createElement(Documents_View_Z721C83C5, {
                            documentId: subView.fields[0],
                        }) : ((subView.tag === 5) ? (($keyZ7232EB07 = (`machine-${machineId}-documents-provider`), createElement(Provider, {
                            key: $keyZ7232EB07,
                            $key: $keyZ7232EB07,
                            children: [($key4DB85DF3 = (`machine-${machineId}-tree`), createElement(DocumentTreeWithFilter, {
                                key: $key4DB85DF3,
                                $key: $key4DB85DF3,
                                groupId: groupId,
                                customerId: customer.Id,
                                machineId: machineId,
                            }))],
                        }))) : createElement("h6", {
                            children: ["Not found"],
                        })))))))),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))));
                }));
            }
        }));
    }));
    return react.createElement(react.Fragment, {}, ...xs_10);
}

